import Screen from '../../../../shared/utils/screen';
import styled from 'styled-components';

const PosterPilotContainer = styled.div<React.CSSProperties>`
  position: absolute;
  bottom: ${116 * Screen.widthRatio}px;
  right: ${124 * Screen.widthRatio}px;
  height: ${350 * Screen.widthRatio}px;
  width: ${230 * Screen.widthRatio}px;
`;

export default PosterPilotContainer;
